import React from "react";
import Ingredient from "./ingredient";
import Button from "./Button";
import Input from "./forms/Input";
import { PlusIcon, MinusIcon } from "@heroicons/react/16/solid";

const Ingredients = ({ ingredients, mode, onChange, isSaving, errors }) => {
  const updateIngredient = (sectionIndex, ingredientIndex, field, value) => {
    const updatedIngredients = ingredients.map((section, sIndex) =>
      sIndex === sectionIndex
        ? {
          ...section,
          items: section.items.map((item, iIndex) =>
            iIndex === ingredientIndex ? { ...item, [field]: value } : item
          ),
        }
        : section
    );
    onChange("ingredients", updatedIngredients);
  }

  const addIngredient = (sectionIndex, ingredientIndex) => {
    const updatedIngredients = ingredients.map((section, sIndex) =>
      sIndex === sectionIndex
        ? {
          ...section,
          items: [
            ...section.items.slice(0, ingredientIndex + 1),
            { quantity: "", units: "", "name": "", "optional": false },
            ...section.items.slice(ingredientIndex + 1)
          ]
        }
        : section
    )
    onChange("ingredients", updatedIngredients)
  }

  const deleteIngredient = (sectionIndex, ingredientIndex) => {
    const updatedIngredients = ingredients.map((section, sIndex) =>
      sIndex === sectionIndex
        ? {
          ...section,
          items: section.items.filter((_, i) => i !== ingredientIndex)
        }
        : section
    )
    onChange("ingredients", updatedIngredients);
  }

  const deleteSection = (index) => {
    const updatedIngredients = ingredients.filter((_, i) => i !== index)

    onChange("ingredients", updatedIngredients);
  }

  const addSection = () => {
    const newSection = {
      section: "",
      items: [
        { quantity: "", units: "", "name": "", "optional": false },
      ],
    };
    onChange("ingredients", [...ingredients, newSection]);
  }

  const handleSectionNameChange = (sectionIndex, newName) => {
    const updatedIngredients = ingredients.map((section, sIndex) =>
      sIndex === sectionIndex ? { ...section, section: newName } : section
    );
    onChange("ingredients", updatedIngredients);
  };


  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Ingredients</h2>
      <div className="mb-4">
        {ingredients.map((section, sectionIndex) => (
          <div key={sectionIndex}>
            {section.section !== null && (
              <h3 className="text-lg font-bold mb-2 flex items-center">
                <Input value={section.section} type="text" onChange={(value) => handleSectionNameChange(sectionIndex, value)} placeholder="Ingredient Section Title" className="w-full" containerClassName="mr-2" fullWidth="True" error="" showError="true" disabled={isSaving} />
                <Button type="gray" onClick={() => deleteSection(sectionIndex)} className="px-1 py-1" disabled={isSaving}>
                  <MinusIcon className="size-4" />
                </Button>
              </h3>
            )}
            <ul className="">
              {section.items.map((ingredient, ingredientIndex) => (
                <li className="mb-4" key={ingredientIndex}>
                  <div className="flex items-center gap-2 flex-wrap">
                    <div>•</div>
                    <Ingredient ingredient={ingredient} key={ingredientIndex} mode={mode} onChange={(field, value) => updateIngredient(sectionIndex, ingredientIndex, field, value)} onDelete={() => deleteIngredient(sectionIndex, ingredientIndex)} index={ingredientIndex} isSaving={isSaving} errors={errors?.[`${sectionIndex}`]?.['items']?.[`${ingredientIndex}`]}/>
                    {ingredientIndex > 0 &&
                      <Button type="gray" onClick={() => deleteIngredient(sectionIndex, ingredientIndex)} className="px-1 py-1" disabled={isSaving}>
                        <MinusIcon className="size-4" />
                      </Button>
                    }
                    <Button type="secondary" className="px-1 py-1" onClick={() => addIngredient(sectionIndex, ingredientIndex)} disabled={isSaving}>
                      <PlusIcon className="size-4" />
                    </Button>
                  </div>
                  {errors?.[`${sectionIndex}`]?.['items']?.[`${ingredientIndex}`] && (
                    <div>
                      <ul className="list-disc list-inside text-sm ml-4 text-red-500">
                        {Object.keys(errors?.[`${sectionIndex}`]?.['items']?.[`${ingredientIndex}`]).map((key) => (
                          <li key={sectionIndex + ingredientIndex + key}>
                            {errors?.[`${sectionIndex}`]?.['items']?.[`${ingredientIndex}`][key]}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <Button type="secondary" onClick={addSection} disabled={isSaving}>Add Section</Button>
    </div>
  )
}

export default Ingredients;